import * as daHelper from '../../Dialogs/dialogActionsHelper';
import {dialogsNames} from '../../../enums/dialogsNames';
import {api as exportApi} from '../../Export/exportActions';
import {ImportTypes} from '../../../enums/importTypes';
import * as qplService from '../../../services/Qpls/qplsService';
import * as kitTypesService from '../../../services/KitTypes/kitTypesService';
import * as toolsService from '../../../services/Tools/toolsService';


const config = {
  getSubmitMethod: (submitConfigData) => {
    return getSubmitMethodByImportType(submitConfigData?.importType);
  }
};

export const actionTypes = {
  ...daHelper.getActionTypes(dialogsNames.IMPORT_FILES_JSON_DIALOG),
};

const actions = {
  ...daHelper.getActions(dialogsNames.IMPORT_FILES_JSON_DIALOG),

};

export let api = {
  ...daHelper.getApiActions(actions, config),

}

export let jsxActions = {
  ...daHelper.getJsxActions(api),

  exportDomSchema(importType) {
    return function (dispatch, getState) {
      let method = getExportDomSchemaMethodByImportType(importType);
      method?.(dispatch, getState)();
    }
  }
};


////////////////////////
function getSubmitMethodByImportType(importType) {
  switch (importType) {
    case ImportTypes.IMPORT_QPL_JSON:
      return qplService.importQplJson;
    case ImportTypes.IMPORT_QPL_FOR_MATERIAL_TYPES_JSON:
      return qplService.importQplForMaterialTypeJson;
    case ImportTypes.IMPORT_KIT_TYPES_JSON:
      return kitTypesService.importKitTypesJson;
    case ImportTypes.IMPORT_TOOL_TYPES_JSON:
      return toolsService.importToolTypesJson;
    default:
      console.log('getSubmitMethodByImportType(): unknown import type: ', importType);
      return null;
  }
}


function getExportDomSchemaMethodByImportType(importType) {
  switch (importType) {
    case ImportTypes.IMPORT_QPL_JSON:
      return exportApi.exportQplDomSchema;
    case ImportTypes.IMPORT_QPL_FOR_MATERIAL_TYPES_JSON:
      return exportApi.exportMaterialQplRulesDomSchema;
    case ImportTypes.IMPORT_KIT_TYPES_JSON:
      return exportApi.exportKitTypesDomSchema;
    case ImportTypes.IMPORT_TOOL_TYPES_JSON:
      return exportApi.exportToolTypesDomSchema;
    default:
      console.log('getExportDomSchemaMethodByImportType(): unknown import type: ', importType);
      return null;
  }
}
